import { SectionContainer, SectionRoot } from '@exploration/shared-components';
import { Badge } from '@midwest/web/indicators';
import { desktop, shadow, tablet } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

export const AdviceServicesStyle = {
  Section: styled(SectionRoot)``,
  Container: styled(SectionContainer)`
    padding-block: 3rem;

    display: flex;
    flex-direction: column;

    ${tablet} {
      padding-block: 4rem 5rem;
    }
  `,
  Title: styled(MDSText.HeroMd)``,

  CTAsContainer: styled.div`
    grid-template-columns: 1fr;
    display: grid;
    gap: 1rem;
    padding-top: 1.5rem;

    ${desktop} {
      grid-template-columns: repeat(4, 1fr);
      gap: 1rem;
      padding-top: 2.5rem;
    }
  `,
  BoxContainer: styled.div`
    padding: 1.5rem;
    border-radius: 0.375rem;
    box-shadow: ${shadow.sm};
    flex: 1;
    align-items: stretch;
    display: flex;
    flex-direction: column;
    --animate-delay: 0.5s;
  `,
  CategoryBadge: styled(Badge)`
    align-self: flex-start;
    margin-bottom: 1rem;
  `,
  Description: styled(MDSText.BodyRegDefault)`
    max-width: 36.75rem;
    padding-top: 0.5rem;
  `,
};
